module.exports = "<div class=\"w3-margin-top\">\r\n    <label><b>{{label}}</b></label>\r\n    <div class=\"onoffswitch\">\r\n        <input type=\"checkbox\" \r\n            name=\"onoffswitch\" \r\n            class=\"onoffswitch-checkbox\" \r\n            id=\"{{label}}-switch\" \r\n            [(ngModel)]=\"value\" \r\n            [disabled]=\"isDisabled\"/>\r\n        <label class=\"onoffswitch-label\" for=\"{{label}}-switch\"></label>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-switch/ztsi-switch.component.html
// module id = ./src/app/components/shared/ztsi-switch/ztsi-switch.component.html
// module chunks = main